<template>
    <div class="cookie-modal">
        <div class="cookie-modal__modal-content">
            <common-icon
                class="cookie-modal__modal-content--close-btn"
                name="close-black"
                size="medium"
                @click="emitEvent({ name: 'close' })"
            ></common-icon>
            <common-icon name="cookie" size="gigantic"></common-icon>
            <p class="cookie-modal__modal-content--message">
                {{ $t('modals.cookies.message') }}
            </p>
            <common-button
                type="secondary"
                size="tiny"
                :label="$t('modals.cookies.button')"
                @click="cookiesAccepted()"
            ></common-button>
        </div>
    </div>
</template>
<script>
    export default {
        methods: {
            cookiesAccepted() {
                this.emitEvent({ name: 'cookiesAccepted' })
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_mixins.scss';

    .cookie-modal {
        position: fixed;
        bottom: 20px;
        right: 20px;
        width: 300px;
        background-color: $color-white;
        box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.2);
        padding: 10px;
        border: 1px;
        border-radius: 20px;
        border-color: $color-border-purple;
        z-index: $layer--notification;
        @include breakpoint(smartphone-large) {
            position: fixed;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
        }

        &__modal-content {
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;

            &--message {
                font-size: $font-size--base;
                margin-bottom: 20px;
                padding: 10px 25px;
            }

            &--close-btn {
                position: absolute;
                top: 10px;
                right: 10px;
                cursor: pointer;
            }
        }
    }

    .subdomain-layout {
        &--navy_black,
        &--black {
            .cookie-modal {
                background-color: $subdomain-black2;
                border-color: $subdomain-almost-black3;
                color: $color-white;
            }
        }
    }
</style>
